module.exports = __webpack_public_path__ + "img/hr-tree-08-d-leaves.eac14d83.png";